import { Fragment, useContext, useEffect, useState } from "react";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal"
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState"
import { ImageOverlayEditor } from "./ImageOverlayEditor";
import { LayerInfo } from "src/common/managers/Types";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { actionAddDataLayer, actionUpdateDataLayer, MapitStateContext } from "src/states/MapitState";

export function ImageOverlayStandalone(
   props: {
      window: ManagedWindow
   }
) {
   let [layerInfo, setLayerInfo] = useState<LayerInfo | null>(props.window.windowParams.layerInfo);
   let { dispatch: windowDispatch } = useWindowContext();
   let { dispatch: mapitStateDispatch, state: mapitState } = useContext(MapitStateContext);

   useEffect(() => {
      setLayerInfo(props.window.windowParams.layerInfo);
   }, [props.window.windowParams.layerInfo]);


   if (!layerInfo) {
      return <div>No layer info provided</div>;
   }


   return <AdvancedDragModal
      window={props.window}
      title="Image Editor"
      PosDefault={{ width: "200px", height: "700px", left: "calc(100% - 12px)", top: "50%", transform: "translate(-100%, -50%)" }}
      onClose={() => windowDispatch(closeWindow(props.window.id))}
   >
      <ADModalBody>
         <Fragment key={layerInfo.layerId + layerInfo.datasetname}>
            <ImageOverlayEditor
               layerInfo={layerInfo}
               onChange={(newLayerInfo) => {
                  windowDispatch(closeWindow(props.window.id));
                  if ((newLayerInfo.layerId ?? -1) == -1) {
                     mapitStateDispatch(actionAddDataLayer(newLayerInfo));
                  } else {
                     mapitStateDispatch(actionUpdateDataLayer(newLayerInfo.layerId, newLayerInfo));
                  }
               }}
            />
         </Fragment>
      </ADModalBody>
   </AdvancedDragModal>
}